import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface OrderOverviewFiltersProps {
  orderType: string;
  status: string;
  onOrderTypeChange: (value: string) => void;
  onStatusChange: (value: string) => void;
}

export const OrderOverviewFilters = ({
  orderType,
  status,
  onOrderTypeChange,
  onStatusChange,
}: OrderOverviewFiltersProps) => {
  return (
    <div className="flex flex-wrap gap-4">
      <Select value={orderType} onValueChange={onOrderTypeChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="ประเภทคำสั่งซื้อ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ทั้งหมด</SelectItem>
          <SelectItem value="NEW">NEW</SelectItem>
          <SelectItem value="CON">CON</SelectItem>
        </SelectContent>
      </Select>

      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="สถานะ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ทั้งหมด</SelectItem>
          <SelectItem value="Confirmed">Confirmed</SelectItem>
          <SelectItem value="Pending">Pending</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
